import { render, staticRenderFns } from "./TheDevGuideLayout.vue?vue&type=template&id=3198e504&"
import script from "./TheDevGuideLayout.vue?vue&type=script&lang=js&"
export * from "./TheDevGuideLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheDevGuideLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports